import axios from "axios";
import { getPortalToken } from "@/lib/portalSession";
import { toast } from "@/lib/toast";
import { API } from "@/api";
export { API };

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function portalHeaders() {
  return { Authorization: `Bearer ${getPortalToken()}` };
}

export async function logPortalAction(action, resourceType, resourceId, filename) {
  try {
    await axios.post(`${API}/portal/audit-log`, {
      action, resource_type: resourceType, resource_id: resourceId, filename,
    }, { headers: portalHeaders() });
  } catch { /* silent */ }
}

export async function secureDownload(fileUrl, filename) {
  const token = getPortalToken();
  if (!token) { toast.error("Session expiree"); return; }
  try {
    const url = fileUrl.startsWith("http") ? fileUrl : `${API_BASE}${fileUrl}`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error(`Erreur ${res.status}`);
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename || "document";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href);
    a.remove();
  } catch (err) {
    toast.error("Erreur de telechargement: " + (err.message || ""));
  }
}

export const STATUS_LABELS = {
  nouveau: "Nouveau", en_attente_documents: "En attente de documents",
  incomplet: "Incomplet", pret_a_traiter: "Pret a traiter",
  en_cours: "En cours de traitement", termine: "Termine",
  transmis: "Transmis", ferme: "Ferme",
};
